import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {LSItem} from '~utils/storage-utils';
import {timeout} from 'rxjs/operators';

@Injectable()
export class ProxyInterceptor implements HttpInterceptor {

  constructor() {
  }

  static readonly tokens: { [key: string]: () => string | null } = {
    'controlTower/': () => localStorage.getItem(LSItem.token),
  };

  static readonly proxy: { [key: string]: (() => string) | string } = {
    'controlTower/': ProxyInterceptor.controlTower,
    'imageApi/': environment.proxy.imageApi,
  };

  public static controlTower(): string {
    const item = sessionStorage.getItem(LSItem.ctUrl);
    return item ?? environment.proxy.controlTower;
  }

  static getToken(request?: HttpRequest<unknown>): string | null {
    return this.getItem(request?.url ?? '', 'TOKEN');
  }

  private static getItem(url: string, item: 'TOKEN' | 'PROXY'): string | null {
    let base: [string, string] | undefined;
    for (const key of Object.keys(this.proxy)) {
      if (url.startsWith(key)) {
        const element = this.proxy[key];
        if (typeof element === 'string') {
          base = [key, element];
        } else {
          base = [key, element()];
        }
        break;
      }
    }
    if (base) {
      const [key, host] = base;
      switch (item) {
        case 'PROXY':
          return `${host}${url.replace(key, '/')}`;
        case 'TOKEN':
          return this.tokens[key] ? this.tokens[key]() : null;
      }
    }
    return url;
  }

  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const url = ProxyInterceptor.getItem(request.url, 'PROXY');
    if (url) {
      request = request.clone({url});
    }
    this.checkAltUrl();
    const defaultTimeoutValue = 60000;
    const timeoutValue = Number(request.headers.get('timeout') ?? defaultTimeoutValue);
    return next.handle(request).pipe(timeout(timeoutValue));
  }

  private checkAltUrl(): void {
    const {controlTower, controlTowerAlt} = environment.proxy;
    if (controlTowerAlt &&
      !sessionStorage.getItem(LSItem.ctUrl) && !sessionStorage.getItem(LSItem.ctCheckUrl)) {
      sessionStorage.setItem(LSItem.ctCheckUrl, '1');
      const req1 = new XMLHttpRequest();
      const req2 = new XMLHttpRequest();
      const load = (req: XMLHttpRequest, url: string) => {
        req.abort();
        sessionStorage.setItem(LSItem.ctUrl, url);
      };
      req1.addEventListener('load', () => load(req2, controlTower));
      req2.addEventListener('load', () => load(req1, controlTowerAlt));
      req1.open('OPTIONS', controlTower + '/version');
      req2.open('OPTIONS', controlTowerAlt + '/version');

      req1.send();
      req2.send();
    }
  }
}
